/**
 * Affiche l'équivalent monétaire des points Runiks sous le compteur.
 *
 * Le compteur (`.Joy-PointCalculator__Points`) est mis à jour et animé par
 * joy-point-calculator.js. On observe donc ses mutations de texte plutôt que
 * de recalculer les points nous-mêmes, pour rester la seule source de vérité.
 */
(function () {
  'use strict';

  const CONTAINER = '#Joy-PointCalculator__Custom--CartDrawer';
  const POINTS = '.Joy-PointCalculator__Points';
  const EQUIVALENT = '.Joy-PointCalculator__Equivalent';

  function formatMoney(amount) {
    try {
      return new Intl.NumberFormat(window.Shopify?.locale || 'fr', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + '€';
    }
  }

  function render(container) {
    const pointsEl = container.querySelector(POINTS);
    const equivalentEl = container.querySelector(EQUIVALENT);
    if (!pointsEl || !equivalentEl) return;

    const points = parseInt((pointsEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    const ratio = parseFloat(container.dataset.pointsPerCurrency) || 50;
    const suffix = container.dataset.equivalentSuffix || '';

    if (points <= 0) {
      equivalentEl.textContent = '';
      return;
    }

    equivalentEl.textContent = '≈ ' + formatMoney(points / ratio) + (suffix ? ' ' + suffix : '');
  }

  const observed = new WeakSet();

  function attach() {
    document.querySelectorAll(CONTAINER).forEach((container) => {
      const pointsEl = container.querySelector(POINTS);
      if (!pointsEl || observed.has(pointsEl)) return;

      observed.add(pointsEl);
      render(container);

      new MutationObserver(() => render(container)).observe(pointsEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  function init() {
    attach();

    // Le tiroir est re-rendu par cart.js à chaque mutation du panier : on
    // ré-attache l'observateur sur les nouveaux noeuds.
    const root = document.querySelector('#CartDrawer') || document.body;
    new MutationObserver(attach).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
